import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import ScrollLock from 'react-scrolllock';
import { rgba, rem } from 'polished';
import { withRouter } from 'next/router';
import { bp, hover } from 'Styles/helpers';
import navColorConfig from 'Styles/navColorConfig';
import Logo from '../logo';
import UnstyledList from '../unstyled-list';
import UnstyledButton from '../unstyled-button';
import { Link } from '../../routes';
import InlineLink from '../inline-link';
import DonateButton from '../donate-button';
import MobileNavButton from './mobile-nav-button';
import { withAuth } from '../auth';

const navList = [
  {
    title: 'Get Involved',
    path: '/get-involved',
  },
];

const popOutNavList = [
  {
    title: 'Our Story',
    path: '/about',
  },
  {
    title: 'Solutions',
    path: '/solutions',
  },
  {
    title: 'Clean Water Corps',
    path: '/clean-water-corps',
  },
  {
    title: 'Partners',
    path: '/partners',
  },
];

const secondaryNavStyles = `
  ${screen.above(bp.portrait, `
    padding-top: 5px;
    display: flex;
    justify-content: flex-end;
  `)}
`;

const LogoWrap = ({ children, route, logoColor, navOpen }) => (
  <Link route="/">
    <LogoLink
      logoColor={logoColor}
      navOpen={navOpen}
      route={route}
      aria-label="Home"
    >
      {route === '/'
        ?
          <h1 style={{ margin: 0 }}>
            {children}
            <span>Waves for Water</span>
          </h1>
        :
          <Fragment>
            {children}
          </Fragment>
      }
    </LogoLink>
  </Link>
);

class Header extends PureComponent {

  constructor() {
    super();
    this.nav = React.createRef();
  }

  static propTypes = {
    navOpen: PropTypes.bool,
    toggleNav: PropTypes.func,
    popOutNavOpen: PropTypes.bool,
    togglePopOutNav: PropTypes.func,
  };

  inArray = list => list.indexOf(this.props.router.route) > -1;

  navColor = () => ({
    logoColor: this.inArray(navColorConfig.whiteLogo) ? '255, 255, 255' : '22, 25, 26',
    navItemColor: this.inArray(navColorConfig.whiteNavItems) ? '255, 255, 255' : '22, 25, 26',
    mobileBackgroundColor: this.inArray(navColorConfig.blackMobileBackground) ? '#16191a' : 'transparent',
    mobileNavItemColor: this.inArray(navColorConfig.whiteMobileItems) ? '255, 255, 255' : '22, 25, 26',
  });

  componentDidMount() {
    this.ticking = false;
    this.currentScrollY = window.scrollY;
    this.previousScrollY = this.currentScrollY;
    this.HideToggleFired = false;
    this.update();
    window.addEventListener('scroll', this.requestTick, false);
  }

  requestTick = () => {
    if (!this.ticking) {
      this.currentScrollY = window.scrollY;
      requestAnimationFrame(this.update);
    }

    this.ticking = true;
  }

  update = () => {
    const buffer = 120;

    this.pinOffset = 60;

    if (window.innerWidth < 1380) {
      this.pinOffset = 40;
    }

    this.ticking = false;
    if (this.nav.current) {
      if (this.currentScrollY > this.pinOffset && !this.nav.current.classList.contains('nav--pinned')) {
        this.nav.current.classList.add('nav--pinned');
      } else if (this.currentScrollY <= this.pinOffset && this.nav.current.classList.contains('nav--pinned')) {
        this.nav.current.classList.remove('nav--pinned');
      }
    }
    if (this.currentScrollY < this.previousScrollY) {

      this.currentDirection = 'up';

      const offset = this.currentScrollY - this.previousScrollY;

      if (
        this.HideToggleFired === false &&
         (this.offsetPrev <= -buffer || this.currentScrollY <= this.pinOffset)
      ) {
        this.slimNav();
        this.HideToggleFired = true;
      }

      if (this.currentDirection !== this.previousDirection) {
        this.offsetPrev = 0;
        this.HideToggleFired = false;
      }
      this.offsetPrev += offset;

    } else {
      this.currentDirection = 'down';
      const offset = this.currentScrollY - this.previousScrollY;

      if (this.HideToggleFired === false && this.offsetPrev >= buffer) {
        this.slimNav(true);
        this.HideToggleFired = true;
      }

      if (this.currentDirection !== this.previousDirection) {
        this.offsetPrev = 0;
        this.HideToggleFired = false;
      }
      this.offsetPrev += offset;
    }

    this.previousDirection = this.currentDirection;
    this.previousScrollY = window.scrollY;
  }

  slimNav = (slim) => {
    if (this.nav.current) {

      if (slim === true) {
        this.nav.current.classList.add('nav--slim');
      } else {
        this.nav.current.classList.remove('nav--slim');
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.nav.current && prevProps && prevProps.router.asPath !== this.props.router.asPath) {
      this.nav.current.classList.remove('nav--pinned', 'nav--slim');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.update, false);
  }

  render() {
    const { navOpen, popOutNavOpen } = this.props;
    const route = this.props.router.asPath;

    return (
      <StyledHeader ref={this.nav} colors={this.navColor()}>
        <HeaderLogo>
          <LogoWrap route={route} navOpen={navOpen} >
            <Logo />
          </LogoWrap>
        </HeaderLogo>

        <DesktopNav navOpen={navOpen} popOutNavOpen={popOutNavOpen}>
          <UnstyledList styles={secondaryNavStyles}>

            {!this.props.loggedIn
              ?
                <Fragment>
                  <SecondaryLink>
                    <Link route="/login">
                      <a>
                        Login
                      </a>
                    </Link>
                  </SecondaryLink>
                  <SecondaryLink>
                    <Link route="/create-account">
                      <a>
                        Signup
                      </a>
                    </Link>
                  </SecondaryLink>
                  <SecondaryLink>
                    <InlineLink href="https://store.wavesforwater.org/collections/all-products">
                      Shop
                    </InlineLink>
                  </SecondaryLink>
                  <DonateButtonLink>
                    <DonateButton className="opaque donate-button" />
                  </DonateButtonLink>
                </Fragment>
              :
                <Fragment>
                  <SecondaryLink>
                    <Link route="/account">
                      <a>
                        My Account
                      </a>
                    </Link>
                  </SecondaryLink>
                  <SecondaryLink>
                    <UnstyledButton onClick={this.props.logout}>
                      Logout
                    </UnstyledButton>
                  </SecondaryLink>
                  <SecondaryLink>
                    <InlineLink href="https://store.wavesforwater.org/collections/all-products">
                      Shop
                    </InlineLink>
                  </SecondaryLink>
                  <DonateButtonLink>
                    <DonateButton className="opaque donate-button" />
                  </DonateButtonLink>
                </Fragment>
            }

          </UnstyledList>

          <Nav aria-label="Main">
            <UnstyledList>
              {navList.map(item => (
                <NavLink
                  key={item.path}
                  isActive={item.path === this.props.router.asPath}
                >
                  <Link route={item.path}>
                    <a className="strikethrough">
                      {item.title}
                    </a>
                  </Link>
                </NavLink>
              ))}

              <NavLink popOutNavOpen={popOutNavOpen}>
                <PopOutNavButton onClick={this.props.togglePopOutNav} popOutNavOpen={popOutNavOpen}>
                  About
                </PopOutNavButton>
                <PopOutNav popOutNavOpen={popOutNavOpen}>

                  {popOutNavList.map(item => (
                    <PopOutNavItem
                      key={item.path}
                      isActive={item.path === this.props.router.asPath}
                    >
                      <Link route={item.path}>
                        <a className="opaque strikethrough">
                          {item.title}
                        </a>
                      </Link>
                    </PopOutNavItem>
                  ))}

                </PopOutNav>
              </NavLink>

              <NavLink isButton>
                <DesktopDonateButton className="opaque donate-button" />
              </NavLink>

            </UnstyledList>
          </Nav>
        </DesktopNav>

        <MobileNav>
          <MobileNavButton onClick={this.props.toggleNav} navOpen={navOpen} />
        </MobileNav>

        <ScrollLock isActive={navOpen} />
      </StyledHeader>
    );
  }
}

const LogoLink = styled.a`
  --anchor-hover-color: rgb(var(--logo-color));
  color: rgb(var(--logo-color));

  ${props => ['/get-involved', '/login'].indexOf(props.route) > -1 && css`
    ${screen.between(bp.portrait, bp.laptopSm, `
      color: ${props.theme.black};
    `)}
  `}

  .nav--pinned & {
    color: #fff;
  }

  ${css`
    ${props => screen.below(bp.portrait, `
      color: ${props.navOpen ? props.theme.black : 'rgb(var(--logo-color))'};

      .nav--pinned & {
        color: ${props.navOpen ? props.theme.black : '#fff'};
      }
    `)}
  `}
`;

const StyledHeader = styled.header`
  --logo-color: ${props => props.colors.logoColor};
  --item-color: ${props => props.colors.navItemColor};
  --mobile-background-color: ${props => props.colors.mobileBackgroundColor};
  --mobile-nav-item-color: ${props => props.colors.mobileNavItemColor};
  display: flex;
  position: absolute;
  right: 0;
  left: 0;
  justify-content: space-between;
  align-items: center;
  padding: 0 74px;
  top: 60px;
  z-index: 99;
  will-change: transform;
  transition: background-color .2s ease-in, transform .2s ease-in;

  ${props => screen.below(bp.portrait, `
    --logo-color: ${props.colors.mobileNavItemColor};
    --item-color: 22, 25, 26;
  `)}

  &::before {
    content: "";
    position: absolute;
    height: calc(100% + 60px);
    width: 100%;
    bottom: 0;
    left: 0;
    pointer-events: none;
    display: block;
    background-color: ${props => props.theme.black};
    z-index: -1;
    opacity: 0;
    transition: opacity .2s ease-in;
  }

  a {
    text-decoration: none;
  }

  &.nav--pinned {
    --mobile-nav-item-color: 255, 255, 255;
    position: fixed;
    top: 0;
    color: #fff;

    &::before {
      opacity: 1;
    }
  }

  ${screen.above(bp.portrait, `
    &.nav--pinned {
      nav {
        border-top-color: rgba(255, 255, 255, .18);
      }
    }

    &.nav--slim {
      transform: translateY(-40px);
    }
  `)}

  ${screen.below(bp.desktop, `
    padding: 0 60px;
  `)}

  ${screen.below(bp.laptop, `
    padding: 0 40px;
    top: 40px;
  `)}

  ${css`
    ${screen.below(bp.portrait, `
      height: 54px;
      padding: 0 20px;
      background-color: var(--mobile-background-color);
      top: 0;
      position: fixed;
    `)}
  `}
`;

const HeaderLogo = styled.div`
  width: 152px;
  height: 54px;
  z-index: 2;

  span {
    opacity: 0;
    position: absolute;
    top: 0;
    left: -9999px;
  }

  transition: transform .2s ease-in;
  transform-origin: bottom left;

  ${screen.above(bp.portrait, `
    .nav--slim & {
      transform: scale(.6) translateY(10px);
    }
  `)}

  ${screen.below(bp.portrait, `
    width: 78px;
    height: 28px;
  `)}
`;

const DesktopNav = styled.div`
  ${props => css`
    ${screen.below(bp.portrait, `
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      padding: 80px 20px 0;
      background-color: #fff;
      opacity: ${props.navOpen ? 1 : 0};
      visibility: ${props.navOpen ? 'visible' : 'hidden'};
      pointer-events: ${props.navOpen ? 'auto' : 'none'};
      transition: opacity ${props.navOpen ? '.25s' : '.17s'} ease-in 0s, visibility ${props.navOpen ? '.25s' : '.17s'} ease-in ${props.navOpen ? '0s' : '.25s'};
    `)}
  `}

  a:not(.opaque),
  button {
    --anchor-hover-color: rgb(var(--item-color));
    color: rgb(var(--item-color));
    transition: color .3s ease-in, opacity .3s ease-in;

    ${hover(`
      opacity: .66;
    `)}

    ${screen.above(bp.portrait, `
      .nav--pinned & {
        color: #fff;
      }
    `)}

    ${props => screen.below(bp.portrait, `
      color: ${props.theme.black};
    `)}
  }

  .nav--pinned & .donate-button {
    ${props => screen.above(bp.portrait, `
      ${hover(`
        color: ${props.theme.blue};
        background-color: ${props.theme.white};
      `)}
    `)}
  }
`;

const DesktopDonateButton = styled(DonateButton)`
  ${screen.below(bp.portrait, `
    display: none;
  `)}
`;

const SecondaryLink = styled.li`
  font-size: 1rem;
  text-align: right;

  &:not(:first-of-type) {
    margin-left: 24px;
  }

  ${screen.below(bp.laptop, `
    font-size: ${rem(15)};
  `)}

  ${screen.below(bp.portrait, `
    display: block;
    text-align: left;
    font-size: 1rem;
    line-height: 2.25;

    &:not(:first-of-type) {
      margin-left: 0;
    }
  `)}
`;

const DonateButtonLink = styled(SecondaryLink)`
  padding-top: 28px;
  margin-top: 24px;
  border-top: 1px solid rgba(var(--item-color), .18);

  ${screen.above(bp.portrait, 'display: none;')}
`;

const Nav = styled.nav`
  position: relative;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: 6px;
  border-top: 1px solid rgba(var(--item-color), .18);

  .strikethrough {
    position: relative;

    &::after {
      display: block;
      position: absolute;
      top: 52%;
      right: -1px;
      left: -1px;
      height: 2px;
      background-color: currentColor;
    }
  }

  ${css`
    ${props => screen.below(bp.portrait, `
      order: -1;
      border-top: 0;
      border-bottom: 1px solid ${rgba(props.theme.black, 0.18)};
      padding-top: 0;
      margin-top: 0;
      margin-bottom: 20px;
      padding-bottom: 20px;
    `)}
  `}
`;

const NavLink = styled.li`
  display: inline-block;

  ${props => props.isActive && css`
    a:hover { opacity: 1; }

    a::after {
      content: "";
    }
  `}

  ${props => !props.isButton && 'font-weight: 600'};

  ${props => props.popOutNavOpen && css`
    button:hover { opacity: 1; }
  `}

  &:not(:first-of-type) {
    margin-left: 34px;

    ${screen.below(bp.laptop, `
      margin-left: 28px;
    `)}

    ${screen.below(bp.laptopSm, `
      margin-left: 24px;
    `)}

    ${screen.below(bp.portrait, `
      margin-left: 0;
    `)}
  }

  ${screen.below(bp.desktop, `
    font-size: ${rem(18)};
  `)}

  ${screen.below(bp.laptop, `
    font-size: 1rem;
  `)}

  ${screen.below(bp.portrait, `
    display: block;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2;
  `)}
`;

const PopOutNavButton = styled(UnstyledButton)`
  ${props => props.popOutNavOpen && `
    && {
      color: ${props.theme.blue};
    }
  `}

  ${screen.below(bp.portrait, `
    display: none;
  `)}
`;

const PopOutNav = styled(UnstyledList)`
  && a {
    color: ${props => props.theme.gray};

    ${props => hover(`
      color: ${props.theme.blue};
    `)}
  }

  ${props => screen.above(bp.portrait, `
    position: absolute;
    top: 62px;
    right: 0;
    padding: 22px 30px 32px;
    background-color: ${props.theme.white};
    box-shadow: 0 0 40px 10px rgba(0, 0, 0, .07);
    opacity: ${props.popOutNavOpen ? 1 : 0};
    visibility: ${props.popOutNavOpen ? 'visible' : 'hidden'};
    pointer-events: ${props.popOutNavOpen ? 'auto' : 'none'};
  `)}

  ${screen.below(bp.portrait, `
    margin-top: 10px;
  `)}
`;

const PopOutNavItem = styled.li`
  ${props => props.isActive && `
    && a {
      &::after {
        content: "";
      }
    }
  `}

  &:not(:first-of-type) {
    margin-top: 16px;
  }
`;

const MobileNav = styled.div`
  display: flex;
  align-items: center;
  z-index: 2;

  ${screen.above(bp.portrait, 'display: none;')}
`;

export default withAuth(withRouter(Header));
